<template>
  <div class="draw-thumb">
    <img
      v-if="image"
      ref="bgImage"
      class="bg-image"
      :class="{ pa: !!sketch }"
    >
    <img
      v-if="sketch"
      ref="sketchImage"
      class="sketch-image"
    >
  </div>
</template>

<script>
export default {
  name: "DrawThumb",

  props: {
    image: { type: String, default: "" },
    sketch: { type: String, default: "" }
  },

  data() {
    return {
      coordinates: null
    };
  },

  watch: {
    sketch() {
      this.redraw();
    }
  },

  mounted() {
    this.redraw();
  },

  methods: {
    /**
     * Load an image
     */
    loadImage(imageSource) {
      return new Promise((resolve, reject) => {
        let image = new Image();
        image.crossOrigin = "Anonymous";
        image.onload = () => resolve(image);
        image.onerror = reject;
        image.src = imageSource;
      });
    },

    /**
     * Draw all points in canvas + add thumb image
     */
    async redraw() {
      // Create canvas
      const canvas = document.createElement("canvas");

      // Set dimensions
      canvas.width = 768;
      canvas.height = 800;

      // Get context
      const ctx = canvas.getContext("2d");

      // Has image
      if (this.image) {
        const image = this.$refs.bgImage;

        image.src = this.image;

        // Is blob
        if (this.image instanceof Blob) {
          image.src = URL.createObjectURL(this.image);
        }
      }

      // Has sketch
      if (this.sketch) {
        this.coordinates = JSON.parse(atob(this.sketch));

        // Draw each point on canvas
        this.coordinates.forEach((coordiante, index) => {
          this.draw(ctx, coordiante, index);
        });

        const img = canvas.toDataURL();
        this.$refs.sketchImage.src = img;
      }
    },

    /**
     * Draw a point inside a canvas
     */
    draw(ctx, coordinate, index) {
      // Set line to be rounded
      ctx.lineCap = "round";
      ctx.lineJoin = "round";

      // Previous coordinate
      const prevItem = this.coordinates[index - 2];

      // Dont go below index 2
      if (index < 2) return;

      // Start drawing
      if (
        !coordinate.isDummy &&
        !this.coordinates[index - 1].isDummy &&
        !prevItem.isDummy
      ) {
        ctx.strokeStyle = coordinate.c;
        ctx.lineWidth = coordinate.r;

        ctx.beginPath();
        ctx.moveTo(prevItem.x, prevItem.y);
        ctx.lineTo(coordinate.x, coordinate.y);
        ctx.stroke();
        ctx.closePath();
      } else if (!coordinate.isDummy) {
        ctx.strokeStyle = coordinate.c;
        ctx.lineWidth = coordinate.r;

        ctx.beginPath();
        ctx.moveTo(coordinate.x, coordinate.y);
        ctx.lineTo(coordinate.x, coordinate.y);
        ctx.stroke();
        ctx.closePath();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.draw-thumb {
  position: relative;
  width: 100%;
  height: 100%;
}

.bg-image {
  width: 100%;
  object-fit: cover;
}

.pa {
  position: absolute;
}

.sketch-image {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 999;
}
</style>
